import React from "react";

import DayCell from "./components/DayCell";
import style from "./index.module.scss";
import moment from "moment";
import classNames from "classnames";
import useWeekCalendar, {
    WeekCalendarProps
} from "../../../../utils/useWeekCalendar";

export default function WeekCalendar({
    data,
    startDate,
    endDate
}: WeekCalendarProps) {
    const { weekDays, table } = useWeekCalendar({ data, startDate, endDate });

    const date = data.map(item => item.date);
    return (
        <div className={style.root}>
            <table>
                <thead>
                    <tr>
                        {weekDays.map(item => (
                            <th
                                key={item.date}
                                className={classNames({
                                    [style.todayTh]: item.isToday
                                })}>
                                {item.day.format("dddd")}
                                <span>
                                    {item.isToday
                                        ? "今天"
                                        : moment(item.date).format("MM-DD")}
                                </span>
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {table.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((column, columnIndex) => (
                                <td
                                    key={columnIndex}
                                    className={classNames({
                                        [style.todayTd]:
                                            weekDays[columnIndex].isToday,
                                        [style.emptyCell]: !column
                                    })}>
                                    <DayCell
                                        course={column}
                                        dateTime={date[columnIndex]}
                                    />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
